'use client';

import { QuestionAnswerDetail } from '@ninjacart/nc-nk-advisory';
import { ReportFastContextProvider } from '@ninjacart/nc-nk-store';
import { ReportBottomSheet } from '@ninjacart/nc-nk-ui';
import { AnimatePresence, YStack, isServer } from 'tamagui';
import { usePathname } from 'next/navigation';

export default function QnaDetailWrapper(props: any) {
  const pathname = usePathname();

  // Split path segments, ignoring empty ones
  const segments = pathname?.split('/').filter(Boolean) || [];

  // Detect if it’s a detail page (like /hi/qna/[slug])
  const isDetailPage =
    segments.includes('qna') && segments.length > (segments[0] === 'qna' ? 1 : 2);
  // Explanation:
  // /qna -> ['qna'] => length 1 → false
  // /hi/qna -> ['hi', 'qna'] => length 2 → false
  // /hi/qna/slug -> ['hi', 'qna', 'slug'] => true ✅

  if (!isDetailPage) return null; // hide completely on list page

  return (
    <AnimatePresence>
      <YStack
        position="absolute"
        fullscreen
        background="trasparent"
        animation="quick"
        enterStyle={{ opacity: isServer ? 1 : 0, x: isServer ? 0 : 200 }}
        exitStyle={{ opacity: isServer ? 1 : 0, x: 0 }}
        space="$4"
        zIndex={999}
      >
        <ReportFastContextProvider>
          <QuestionAnswerDetail qnaId={props?.id} lang={props?.lang} />
          <ReportBottomSheet />
        </ReportFastContextProvider>
      </YStack>
    </AnimatePresence>
  );
}
